/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { CheckGiftXHandleResponse, CheckGiftXHandleVars } from '../openapi-types.gen.js';

export type { CheckGiftXHandleResponse, CheckGiftXHandleVars } from '../openapi-types.gen.js';

export const useCheckGiftXHandle = createMutationHook<CheckGiftXHandleVars, CheckGiftXHandleResponse, unknown>({
  specName: 'useCheckGiftXHandle',
  path: '/v1/gifts/x-handle-check',
  method: 'POST',
  resolveUrl: (vars: CheckGiftXHandleVars) => `/v1/gifts/x-handle-check`,
  buildBody: (vars: CheckGiftXHandleVars) => ({ handle: vars.handle }),
  parseResponse: (raw: unknown): CheckGiftXHandleResponse => raw as CheckGiftXHandleResponse,
  
  
  
});
